module.exports = __webpack_public_path__ + "img/preview-4.cc845925.webp";